import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { AUTH } from "@/constants/testIds";
import { CodiraBrand } from "@/components/Brand";
import { ArrowRight } from "lucide-react";

export default function Login() {
  const { login, error } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@codira.io");
  const [password, setPassword] = useState("codira2026");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email, password);
    setBusy(false);
    if (ok) nav("/");
  };

  return (
    <div className="min-h-screen w-full bg-white flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-10">
          <CodiraBrand className="h-9" />
        </div>

        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1.5">
              Email
            </label>
            <input
              data-testid={AUTH.emailInput}
              type="email" required
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-lg border border-gray-200 focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/20 px-3.5 py-2.5 text-sm transition-all"
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1.5">
              Password
            </label>
            <input
              data-testid={AUTH.passwordInput}
              type="password" required
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-lg border border-gray-200 focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/20 px-3.5 py-2.5 text-sm transition-all"
            />
          </div>

          {error && (
            <p data-testid={AUTH.errorMsg} className="text-red-600 text-xs">{error}</p>
          )}

          <button
            data-testid={AUTH.loginBtn}
            type="submit" disabled={busy}
            className="btn-brand w-full py-2.5 text-sm flex items-center justify-center gap-2"
          >
            {busy ? "Signing in..." : (<>Sign in <ArrowRight className="h-4 w-4" /></>)}
          </button>
        </form>
      </div>
    </div>
  );
}
